<template>
    <pw-header/>
    <main class="main" v-bind="$attrs">
        <router-view></router-view>
    </main>
</template>
<script setup>
import PwHeader from '../pwComponents/PwHeader/PwHeader.vue';
</script>
<style lang="scss" scoped>
.main {
    padding-top: 64px;
}

.has-bottom {
    margin-bottom: 80px;
}
</style>